import * as Request from '../../request'
import * as Constants from './constants'
import * as Types from './types'

export const updateField = (field: Types.FieldChange) =>
  ({type: Constants.UPDATE_CREATE_COMMUNITY_FIELD, field})

export const onSubmitAccountCreate: Types.OnSubmit =
  (fields: Types.Fields, currentCommunity: string) =>
    Request.requestActionCreator<Types.SubmitOptions>(Constants.CREATE_COMMUNITY)
    ({
      method: 'POST',
      payload: {
        guid: fields.guid,
        name: fields.name,
        selectedCommunity: currentCommunity,
      },
      url: '/communities/account',
    })

export const onSubmitNewsletterCreate: Types.OnSubmit =
  (fields: Types.Fields, currentCommunity: string) =>
  Request.requestActionCreator<Types.SubmitOptions>(Constants.CREATE_COMMUNITY)
  ({
    method: 'POST',
    payload: {
      guid: fields.guid,
      name: fields.name,
      selectedCommunity: currentCommunity,
    },
    url: '/communities/newsletter',
  })



// WEBPACK FOOTER //
// ./src/pages/create-community/actions.ts